const messages = {
  [`main.count`]: "order count",
};


export default messages
